"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var i18next_1 = __importDefault(require("i18next"));
var core_1 = require("@material-ui/core");
var createLinkForm_1 = __importDefault(require("./styles/createLinkForm"));
var validation_1 = require("../../../../shared/util/validation");
var constants_1 = require("../../../../shared/constants");
var ModalMargins_1 = __importDefault(require("./ModalMargins"));
var refresh_icon_svg_1 = __importDefault(require("./assets/refresh-icon.svg"));
var LinkIcon_1 = __importDefault(require("../../widgets/LinkIcon"));
var FileIcon_1 = __importDefault(require("../../widgets/FileIcon"));
var CsvIcon_1 = __importDefault(require("../../widgets/CsvIcon"));
var StarIcon_1 = __importDefault(require("../../widgets/StarIcon"));
var format_1 = require("../../../app/util/format");
var CollapsibleMessage_1 = __importDefault(require("../../../app/components/CollapsibleMessage"));
var CreateTypeButton_1 = __importDefault(require("./components/CreateTypeButton"));
var types_1 = require("../../../app/components/CollapsibleMessage/types");
var download_1 = require("../../../app/util/download");
var FileInputField_1 = require("../../widgets/FileInputField");
var actions_1 = __importDefault(require("../../actions"));
var ga_1 = require("../../../app/util/ga");
var constants_2 = require("../../constants");
var FormStartAdorment_1 = __importDefault(require("./FormStartAdorment"));
var Tooltip_1 = __importDefault(require("../../widgets/Tooltip"));
var TagsAutocomplete_1 = __importDefault(require("../../widgets/TagsAutocomplete"));
var CreateType;
(function (CreateType) {
    CreateType["LINK"] = "link";
    CreateType["FILE"] = "file";
    CreateType["BULK"] = "bulk";
})(CreateType || (CreateType = {}));
var CreateLinkForm = function (_a) {
    var onSubmitLink = _a.onSubmitLink, onSubmitFile = _a.onSubmitFile, onSubmitBulk = _a.onSubmitBulk;
    var shortUrl = (0, react_redux_1.useSelector)(function (state) { return state.user.shortUrl; });
    var longUrl = (0, react_redux_1.useSelector)(function (state) { return state.user.longUrl; });
    var tags = (0, react_redux_1.useSelector)(function (state) { return state.user.tags; });
    var isUploading = (0, react_redux_1.useSelector)(function (state) { return state.user.isUploading; });
    var createShortLinkError = (0, react_redux_1.useSelector)(function (state) { return state.user.createShortLinkError; });
    var uploadFileError = (0, react_redux_1.useSelector)(function (state) { return state.user.uploadFileError; });
    var dispatch = (0, react_redux_1.useDispatch)();
    var setShortUrl = function (shortUrl) {
        return dispatch(actions_1.default.setShortUrl(shortUrl));
    };
    var setLongUrl = function (longUrl) {
        return dispatch(actions_1.default.setLongUrl(longUrl));
    };
    var setRandomShortUrl = function () { return dispatch(actions_1.default.setRandomShortUrl()); };
    var setUploadFileError = function (error) {
        return dispatch(actions_1.default.setUploadFileError(error));
    };
    var setCreateShortLinkError = function (error) {
        return dispatch(actions_1.default.setCreateShortLinkError(error));
    };
    var setTags = function (tags) { return dispatch(actions_1.default.setTags(tags)); };
    var history = (0, react_router_dom_1.useHistory)();
    var _b = __read((0, react_1.useState)(CreateType.LINK), 2), createType = _b[0], setCreateType = _b[1];
    var _c = __read((0, react_1.useState)(null), 2), file = _c[0], setFile = _c[1];
    var _d = __read((0, react_1.useState)(''), 2), tagInput = _d[0], setTagInput = _d[1];
    var classes = (0, createLinkForm_1.default)({
        textFieldHeight: constants_2.TEXT_FIELD_HEIGHT,
        uploadFileError: uploadFileError,
        createShortLinkError: createShortLinkError,
    });
    var submitDisabled = function () {
        var isInvalidTags = !(0, validation_1.isValidTags)(tags) ||
            !(0, validation_1.isValidTag)(tagInput, true) ||
            tags.includes(tagInput);
        switch (createType) {
            case CreateType.LINK:
                return (!(0, validation_1.isValidShortUrl)(shortUrl, false) ||
                    !(0, validation_1.isValidLongUrl)(longUrl, false) ||
                    !!createShortLinkError ||
                    isInvalidTags);
            case CreateType.FILE:
                return (!(0, validation_1.isValidShortUrl)(shortUrl, false) ||
                    !file ||
                    !!uploadFileError ||
                    isUploading ||
                    !!createShortLinkError ||
                    isInvalidTags);
            case CreateType.BULK:
                return !file || !!uploadFileError || isUploading || isInvalidTags;
            default:
                console.log('error, unrecognised createType');
                return true;
        }
    };
    (0, react_1.useEffect)(function () {
        setFile(null); // reset file state if toggling between createType
        setUploadFileError('');
        switch (createType) {
            case CreateType.LINK:
                (0, ga_1.GAEvent)('modal page', 'click url tab');
                break;
            case CreateType.FILE:
                (0, ga_1.GAEvent)('modal page', 'click file tab');
                break;
            case CreateType.BULK:
                (0, ga_1.GAEvent)('modal page', 'click bulk tab');
                break;
            default:
                console.log('error, unrecognised createType');
        }
    }, [createType]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Hidden, { smUp: true },
            react_1.default.createElement(core_1.Divider, null)),
        react_1.default.createElement(ModalMargins_1.default, null,
            react_1.default.createElement("form", { className: classes.form, onSubmit: function (e) {
                    e.preventDefault();
                    switch (createType) {
                        case CreateType.LINK:
                            onSubmitLink(history);
                            break;
                        case CreateType.FILE:
                            onSubmitFile(file);
                            break;
                        case CreateType.BULK:
                            onSubmitBulk(file);
                            break;
                        default:
                            console.log('error, unrecognised createType');
                    }
                } },
                react_1.default.createElement("div", { color: "primary", className: classes.linkTypeWrapper },
                    react_1.default.createElement(CreateTypeButton_1.default, { InputProps: { classes: classes }, Icon: LinkIcon_1.default, isEnabled: createType !== CreateType.LINK, onChange: function () { return setCreateType(CreateType.LINK); } }, "To a URL"),
                    react_1.default.createElement(CreateTypeButton_1.default, { InputProps: { classes: classes }, Icon: FileIcon_1.default, isEnabled: createType !== CreateType.FILE, onChange: function () { return setCreateType(CreateType.FILE); } }, "To a File"),
                    react_1.default.createElement(CreateTypeButton_1.default, { InputProps: { classes: classes }, Icon: CsvIcon_1.default, isEnabled: createType !== CreateType.BULK, onChange: function () { return setCreateType(CreateType.BULK); } }, "From a .csv")),
                createType === CreateType.LINK && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(core_1.Typography, { className: classes.labelText, variant: "body1" },
                        "Original link (this will be ",
                        react_1.default.createElement("strong", null, "publicly"),
                        " indexable by search engines)"),
                    react_1.default.createElement(core_1.TextField, { error: !(0, validation_1.isValidLongUrl)(longUrl, true), InputProps: {
                            className: classes.outlinedInput,
                            classes: {
                                input: classes.input,
                            },
                            startAdornment: (react_1.default.createElement(FormStartAdorment_1.default, null, "https://")),
                        }, required: true, variant: "outlined", placeholder: "Enter URL", onChange: function (event) { return setLongUrl(event.target.value); }, value: longUrl, helperText: (0, validation_1.isValidLongUrl)(longUrl, true)
                            ? ''
                            : "This doesn't look like a valid URL." }))),
                createType === CreateType.FILE && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: classes.fileInputDescWrapper },
                        react_1.default.createElement(core_1.Typography, { className: classes.labelText, variant: "body1" },
                            "Choose your file (this will be ",
                            react_1.default.createElement("strong", null, "publicly"),
                            ' ',
                            "indexable by search engines)"),
                        react_1.default.createElement("div", { className: classes.maxSizeTextWrapper },
                            react_1.default.createElement(core_1.Typography, { variant: "caption", className: classes.maxSizeText },
                                "Maximum size ",
                                (0, format_1.formatBytes)(constants_1.MAX_FILE_UPLOAD_SIZE)))),
                    react_1.default.createElement(FileInputField_1.FileInputField, { textFieldHeight: constants_2.TEXT_FIELD_HEIGHT, fileNameText: file ? file.name : 'No file selected', uploadFileError: uploadFileError, setFile: setFile, setUploadFileError: setUploadFileError, buttonText: "Browse", fileSizeText: file ? (0, format_1.formatBytes)(file.size) : '', isUploading: isUploading, maxSize: constants_1.MAX_FILE_UPLOAD_SIZE }),
                    react_1.default.createElement(CollapsibleMessage_1.default, { visible: !!uploadFileError, type: types_1.CollapsibleMessageType.Error }, uploadFileError))),
                createType !== CreateType.BULK && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: classes.labelText },
                        react_1.default.createElement(core_1.Typography, { variant: "body1" },
                            "Short link (",
                            react_1.default.createElement("strong", null, "cannot be deleted"),
                            " after creation)")),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(core_1.TextField, { disabled: isUploading, error: !(0, validation_1.isValidShortUrl)(shortUrl, true), className: classes.shortUrlInput, InputProps: {
                                className: classes.outlinedInput,
                                classes: {
                                    input: classes.input,
                                    notchedOutline: classes.inputNotchedOutline,
                                },
                                startAdornment: (react_1.default.createElement(FormStartAdorment_1.default, null, i18next_1.default.t('general.shortUrlPrefix'))),
                                endAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "end" },
                                    react_1.default.createElement(core_1.IconButton, { className: classes.refreshIcon, onClick: function () {
                                            setRandomShortUrl();
                                            setCreateShortLinkError('');
                                        }, size: "small", disabled: isUploading },
                                        react_1.default.createElement("img", { src: refresh_icon_svg_1.default, className: classes.iconTest, alt: "Get new short link" })))),
                            }, required: true, variant: "outlined", placeholder: "your customised link", onChange: function (event) {
                                setShortUrl(event.target.value);
                                setCreateShortLinkError('');
                            }, value: shortUrl, helperText: (0, validation_1.isValidShortUrl)(shortUrl, true)
                                ? ''
                                : 'Short links should only consist of lowercase letters, numbers and hyphens.' }),
                        react_1.default.createElement(CollapsibleMessage_1.default, { visible: !!createShortLinkError, type: types_1.CollapsibleMessageType.Error },
                            react_1.default.createElement("a", { className: classes.shortLinkError, href: "/#/directory?query=".concat(shortUrl) }, createShortLinkError))))),
                createType === CreateType.BULK && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: classes.bulkUploadDescWrapper },
                        react_1.default.createElement(StarIcon_1.default, null),
                        react_1.default.createElement(core_1.Typography, { className: "".concat(classes.bulkUploadDescText), variant: "body1" },
                            "New feature to shorten your original links in bulk! Here is how:",
                            react_1.default.createElement("br", null),
                            "1.",
                            ' ',
                            react_1.default.createElement(core_1.Button, { onClick: download_1.downloadSampleBulkCsv, className: classes.bulkSampleDownloadText }, "Download template .csv file"),
                            react_1.default.createElement("br", null),
                            "2. Fill up the template file with your links (up to 1000 links)",
                            react_1.default.createElement("br", null),
                            "3. Upload the .csv file here ",
                            react_1.default.createElement("br", null))),
                    react_1.default.createElement("div", { className: classes.fileInputDescWrapper },
                        react_1.default.createElement(core_1.Typography, { className: classes.labelText, variant: "body1" },
                            "Choose your ",
                            react_1.default.createElement("b", null, ".csv"),
                            " file (the links in this file will be",
                            ' ',
                            react_1.default.createElement("b", null, "publicly indexable"),
                            " by search engines)"),
                        react_1.default.createElement("div", { className: classes.maxSizeTextWrapper },
                            react_1.default.createElement(core_1.Typography, { variant: "caption", className: classes.maxSizeText },
                                "Maximum size ",
                                (0, format_1.formatBytes)(constants_1.MAX_CSV_UPLOAD_SIZE)))),
                    react_1.default.createElement(FileInputField_1.FileInputField, { textFieldHeight: constants_2.TEXT_FIELD_HEIGHT, fileNameText: file ? file.name : 'No file selected', uploadFileError: uploadFileError, setFile: setFile, setUploadFileError: setUploadFileError, buttonText: "Browse", fileSizeText: file ? (0, format_1.formatBytes)(file.size) : '', isUploading: isUploading, acceptedTypes: ".csv", maxSize: constants_1.MAX_CSV_UPLOAD_SIZE }),
                    react_1.default.createElement(CollapsibleMessage_1.default, { visible: !!uploadFileError, type: types_1.CollapsibleMessageType.Error }, uploadFileError),
                    react_1.default.createElement("div", { className: classes.maxSizeTextWrapper },
                        react_1.default.createElement(core_1.Typography, { variant: "caption", className: classes.maxSizeText },
                            "Only CSV format files are allowed. ",
                            react_1.default.createElement("br", null),
                            "If you have an Excel file, please convert it by going to File > Save As > CSV (Comma delimited).")))),
                react_1.default.createElement("div", { className: classes.labelText },
                    react_1.default.createElement(core_1.Typography, { variant: "body1" },
                        "Tag (add up to ",
                        react_1.default.createElement("strong", null,
                            constants_1.MAX_NUM_TAGS_PER_LINK,
                            " tags"),
                        ")",
                        ' ',
                        react_1.default.createElement(Tooltip_1.default, { title: "Tags are words, or combinations of words, you can use to classify or describe your link.", imageAltText: "Tags help" }))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(TagsAutocomplete_1.default, { tags: tags, setTags: setTags, tagInput: tagInput, setTagInput: setTagInput, disabled: isUploading || tags.length >= constants_1.MAX_NUM_TAGS_PER_LINK, fixHelperTextPosition: false })),
                react_1.default.createElement(core_1.Button, { className: classes.button, type: "submit", size: "large", variant: "contained", color: "primary", disabled: submitDisabled() }, isUploading ? (react_1.default.createElement(core_1.CircularProgress, { color: "primary", size: 20 })) : ('Create'))))));
};
exports.default = CreateLinkForm;
